import { jsxs as s, jsx as e, Fragment as C } from "react/jsx-runtime";
import m from "@mui/material/Box";
import { useMediaRemote as A, useActiveTextTrack as M, useTextCues as j, useMediaState as v, useCaptionOptions as H, Tooltip as d, CaptionButton as mt, Menu as f, SeekButton as ht, useChapterTitle as et, ChapterTitle as nt, Title as ot, usePlaybackRateOptions as pt, PlayButton as it, PIPButton as ft, MuteButton as vt, VolumeSlider as w, TimeSlider as T } from "@vidstack/react";
import { useDefaultLayoutContext as k, DefaultVideoLayout as gt, defaultLayoutIcons as xt } from "@vidstack/react/player/layouts/default";
import "@vidstack/react/player/styles/default/theme.css";
import "@vidstack/react/player/styles/default/layouts/video.css";
import { useState as I, useMemo as st, useEffect as D, useRef as B } from "react";
import { ClosedCaptionsOnIcon as _, ClosedCaptionsIcon as q, CheckIcon as V, XMarkIcon as bt, PreviousIcon as Ct, NextIcon as Tt, LanguageIcon as Nt, OdometerIcon as St, ReplayIcon as lt, PlayIcon as yt, PauseIcon as It, PictureInPictureExitIcon as wt, PictureInPictureIcon as kt, MuteIcon as Bt, VolumeLowIcon as Rt, VolumeHighIcon as Mt, PlaylistIcon as Et } from "@vidstack/react/icons";
import "@mui/material/styles";
import "@mui/material/CssBaseline";
import { I as N, as as E } from "./Slider-vVmtecg6.js";
import { alpha as $ } from "@mui/material";
import "@mui/material/useAutocomplete";
import "@fortawesome/pro-regular-svg-icons";
import "@emotion/cache";
import "@emotion/react";
import "@mui/material/Typography";
import "@fortawesome/react-fontawesome";
import "@fortawesome/fontawesome-svg-core";
import "@mui/material/Checkbox";
import "@fortawesome/pro-solid-svg-icons";
import "@fortawesome/pro-light-svg-icons";
import Lt from "@mui/material/Stack";
import "@mui/material/Link";
import "@mui/material/Tooltip";
import z from "@mui/material/Fade";
import "@mui/material/Button";
import "@fortawesome/pro-regular-svg-icons/faXmark";
import "@fortawesome/pro-solid-svg-icons/faCircle";
import "@mui/material/Chip";
import "@mui/material/Avatar";
import "@fortawesome/pro-light-svg-icons/faUser";
import "@mui/material/AvatarGroup";
import "@fortawesome/pro-regular-svg-icons/faPlus";
import "@mui/material/LinearProgress";
import "@mui/material/Tabs";
import "@mui/material/Tab";
import "./Tab-CO75KpXL.js";
import "@mui/material/ButtonGroup";
import "@mui/material/Switch";
import "@mui/material/Radio";
import "@mui/material/FormLabel";
import "@mui/material/Autocomplete";
import "@mui/material/FormHelperText";
import "@mui/material/FormControl";
import "@mui/material/OutlinedInput";
import "@mui/material/Input";
import "@mui/material/InputAdornment";
import "@fortawesome/pro-regular-svg-icons/faMagnifyingGlass";
import "@fortawesome/pro-solid-svg-icons/faCheck";
import "@fortawesome/pro-regular-svg-icons/faCircleQuestion";
import "@react-spring/web";
import "./ContentPanel-DRC79oum.js";
import "react-dropzone";
import J from "@mui/material/Popper";
import { faLinkSimple as zt } from "@fortawesome/pro-regular-svg-icons/faLinkSimple";
import "copy-text-to-clipboard";
import { faExpandWide as Ot } from "@fortawesome/pro-solid-svg-icons/faExpandWide";
import { faCompressWide as Ft } from "@fortawesome/pro-solid-svg-icons/faCompressWide";
import { faUpRightAndDownLeftFromCenter as Dt } from "@fortawesome/pro-solid-svg-icons/faUpRightAndDownLeftFromCenter";
import { faDownLeftAndUpRightToCenter as Gt } from "@fortawesome/pro-solid-svg-icons/faDownLeftAndUpRightToCenter";
import { faChevronsRight as Wt } from "@fortawesome/pro-solid-svg-icons/faChevronsRight";
import { faChevronsLeft as At } from "@fortawesome/pro-solid-svg-icons/faChevronsLeft";
import { faToggleLargeOn as jt } from "@fortawesome/pro-solid-svg-icons/faToggleLargeOn";
import { faToggleOff as Vt } from "@fortawesome/pro-solid-svg-icons/faToggleOff";
import { faEye as $t } from "@fortawesome/pro-solid-svg-icons/faEye";
import "react-use";
import "color";
import "react-rnd";
import "react-hotkeys-hook";
import "./AutoScrollContainer-CzyjIY1o.js";
import "@tanstack/react-table";
import "@fortawesome/pro-regular-svg-icons/faArrowRight";
import "@fortawesome/pro-regular-svg-icons/faArrowLeft";
import "@fortawesome/pro-regular-svg-icons/faPenToSquare";
import "@fortawesome/pro-regular-svg-icons/faCircleXmark";
import "@fortawesome/pro-regular-svg-icons/faArrowDown";
import "@mui/material/Slider";
import { faArrowUpRightFromSquare as Ut } from "@fortawesome/pro-light-svg-icons/faArrowUpRightFromSquare";
import { faArrowRight as Ht } from "@fortawesome/pro-solid-svg-icons/faArrowRight";
import { T as S } from "./Typography-HkIo7ajX.js";
import { s as u } from "./spacings-C27fg6SF.js";
import { r as y } from "./roundings-rAN_HXvA.js";
import { T as _t } from "./Tooltip-CKVc9519.js";
import { c as qt } from "./copy-to-clipboard-BbQlH4dk.js";
import { L as rt } from "./Logo-agH5zvpp.js";
import { S as at } from "./ShadowBox-Bn6vo7Kx.js";
const ct = () => {
  const t = A(), n = M("chapters"), i = j(n);
  return {
    ctaGoTo: ({
      isEnabled: l,
      goToType: o,
      goTo: r,
      goToHandler: a
    }) => {
      if (!l)
        return;
      const c = () => {
        var h;
        switch (o) {
          case "goToStep":
            t.seek((h = i[Number(r)]) == null ? void 0 : h.startTime), t.play();
            break;
          case "guiddeLink":
            t.pause(), window.open(String(r), "_self");
            break;
          case "externalLink":
            t.pause(), window.open(String(r), "_blank");
            break;
        }
      };
      if (typeof a == "function") {
        a(c);
        return;
      }
      c();
    }
  };
}, Jt = {
  bottomLeft: {
    bottom: "0",
    left: "0"
  },
  bottomRight: {
    bottom: "0",
    right: "0"
  },
  topRight: {
    top: "0",
    right: "0"
  },
  topLeft: {
    top: "0",
    left: "0"
  }
}, Xt = ({
  isEnabled: t,
  position: n,
  text: i,
  image: l = "",
  goToType: o,
  goTo: r,
  goToHandler: a = void 0,
  onCtaClick: c = () => {
  }
}) => {
  const [h, p] = I(!1), [x, b] = I(!0), { isSmallLayout: g } = k(), dt = st(() => l ? h ? 1 : 0 : 1, [l, h]), { ctaGoTo: ut } = ct();
  if (!t)
    return null;
  const U = g ? "topRight" : n, L = U.toLowerCase();
  return /* @__PURE__ */ s(
    at,
    {
      shadowSize: "md",
      onClick: () => {
        c(), ut({ isEnabled: t, goToType: o, goTo: r, goToHandler: a });
      },
      className: "cta cta-single",
      sx: (G) => ({
        display: "flex",
        alignItems: "center",
        position: "absolute",
        zIndex: 11,
        m: u.sm,
        gap: u.sm,
        px: u.sm,
        py: u.xs,
        maxWidth: "max(300px, 40%)",
        backgroundColor: G.palette.common.white,
        color: G.palette.common.black,
        borderRadius: y.xs,
        border: `1px solid ${G.palette.grey[300]}`,
        cursor: "pointer",
        opacity: dt,
        ...Jt[U]
      }),
      ...L.includes("bottom") && { "data-vertical-position": "bottom" },
      ...L.includes("top") && { "data-vertical-position": "top" },
      ...L.includes("left") && { "data-horizontal-position": "left" },
      ...L.includes("right") && { "data-horizontal-position": "right" },
      children: [
        !!l && !!x && /* @__PURE__ */ e(m, { sx: { maxWidth: 85, height: 30 }, children: /* @__PURE__ */ e(
          "img",
          {
            src: l,
            alt: "cta-picture",
            style: { objectFit: "cover", width: "100%", height: "100%" },
            onLoad: () => {
              p(!0), b(!0);
            },
            onError: () => {
              p(!0), b(!1);
            }
          }
        ) }),
        /* @__PURE__ */ e(S, { variant: "text", children: i })
      ]
    }
  );
}, Yt = ({ title: t = "", actions: n, onCtaClick: i = () => {
} }) => {
  const l = v("playing"), { isSmallLayout: o } = k(), r = A();
  D(() => {
    r.pause();
  }, []);
  const { ctaGoTo: a } = ct();
  return l ? null : /* @__PURE__ */ e(
    m,
    {
      className: "cta cta-multiple",
      sx: (c) => ({
        position: "absolute",
        inset: 0,
        zIndex: 11,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: $(c.palette.common.black, 0.5),
        border: `1px solid ${c.palette.grey[300]}`,
        backdropFilter: "blur(4px)"
      }),
      children: /* @__PURE__ */ s(
        m,
        {
          sx: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            textAlign: "center",
            borderRadius: y.md,
            p: u.xl,
            gap: u.xl
          },
          children: [
            !!t && /* @__PURE__ */ e(
              S,
              {
                variant: "text",
                size: "xl",
                fontWeight: "semibold",
                color: "white",
                children: t
              }
            ),
            /* @__PURE__ */ s(
              m,
              {
                sx: {
                  display: "flex",
                  flexDirection: "column",
                  ...o && {
                    height: "80%"
                  }
                },
                children: [
                  /* @__PURE__ */ e(
                    m,
                    {
                      sx: {
                        display: "flex",
                        justifyContent: "center",
                        flexWrap: "wrap",
                        gap: u.lg,
                        ...o && {
                          overflow: "auto",
                          margin: "auto"
                        }
                      },
                      children: n.map((c, h) => c.isEnabled ? /* @__PURE__ */ s(
                        at,
                        {
                          shadowSize: "sm",
                          onClick: () => {
                            i(), a({
                              isEnabled: c.isEnabled,
                              goToType: c.goToType,
                              goTo: c.goTo,
                              goToHandler: c.goToHandler
                            });
                          },
                          sx: (p) => ({
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            alignSelf: "center",
                            width: "100%",
                            maxWidth: o ? "160px" : "260px",
                            px: o ? u.md : u.xl,
                            py: o ? u.xs : u.md,
                            gap: u.xs,
                            background: p.palette.common.white,
                            color: p.palette.common.black,
                            borderRadius: y.full,
                            cursor: "pointer"
                          }),
                          children: [
                            /* @__PURE__ */ s(m, { sx: { display: "flex", alignItems: "center" }, children: [
                              /* @__PURE__ */ e(m, { sx: { mr: u.md }, children: "•" }),
                              /* @__PURE__ */ e(
                                S,
                                {
                                  variant: "text",
                                  size: o ? "xs" : "sm",
                                  children: c.text
                                }
                              )
                            ] }),
                            c.goToType === "externalLink" && /* @__PURE__ */ e(
                              N,
                              {
                                icon: Ut,
                                size: o ? "xs" : "sm"
                              }
                            )
                          ]
                        },
                        h
                      ) : null)
                    }
                  ),
                  /* @__PURE__ */ s(
                    m,
                    {
                      sx: (c) => ({
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: u.md,
                        mt: u.xl,
                        textTransform: "uppercase",
                        color: c.palette.common.white,
                        border: `1px solid ${c.palette.common.white}`,
                        px: o ? u.md : u.xl,
                        py: o ? u.xs : u.md,
                        mx: "auto",
                        borderRadius: y.full,
                        cursor: "pointer"
                      }),
                      onClick: () => {
                        r.play();
                      },
                      children: [
                        /* @__PURE__ */ e(N, { icon: Ht }),
                        /* @__PURE__ */ e(
                          S,
                          {
                            variant: "text",
                            fontWeight: "bold",
                            size: o ? "xs" : "md",
                            children: "skip"
                          }
                        )
                      ]
                    }
                  )
                ]
              }
            )
          ]
        }
      )
    }
  );
}, Kt = ({ ctas: t, onCtaClick: n = () => {
} }) => {
  const i = v("currentTime"), l = M("chapters"), o = j(l);
  return !t.length || !o.length ? null : t.map((r, a) => {
    var x, b, g;
    const c = () => {
      n(r);
    }, p = ((x = o[r.chapterIndex]) == null ? void 0 : x.endTime) - i;
    switch (r.type) {
      case "single":
        return i > ((b = o[r.chapterIndex]) == null ? void 0 : b.startTime) && i < ((g = o[r.chapterIndex]) == null ? void 0 : g.endTime) ? /* @__PURE__ */ e(
          Xt,
          {
            ...r.action,
            onCtaClick: c
          },
          a
        ) : null;
      case "multiple":
        return p <= 0.3 && p >= 0 ? /* @__PURE__ */ e(
          Yt,
          {
            ...r,
            onCtaClick: c
          },
          a
        ) : null;
      default:
        return null;
    }
  });
}, X = ({ onChange: t = () => {
} }) => {
  var a;
  const n = H(), i = ((a = n.selectedTrack) == null ? void 0 : a.label) ?? "Off", l = H({ off: !1 }), o = B(null);
  if (!l.length)
    return null;
  if (l.length === 1)
    return /* @__PURE__ */ s(d.Root, { children: [
      /* @__PURE__ */ e(d.Trigger, { asChild: !0, children: /* @__PURE__ */ s(
        mt,
        {
          className: "vds-button",
          onChange: () => {
            t(i);
          },
          children: [
            /* @__PURE__ */ e(_, { className: "vds-icon vds-icon-on" }),
            /* @__PURE__ */ e(q, { className: "vds-icon vds-icon-off" })
          ]
        }
      ) }),
      /* @__PURE__ */ s(d.Content, { className: "vds-tooltip-content", children: [
        "Captions (",
        i,
        ")"
      ] })
    ] });
  const r = /* @__PURE__ */ e(
    f.Content,
    {
      className: "vds-menu-items",
      placement: "top end",
      children: /* @__PURE__ */ e(
        f.RadioGroup,
        {
          className: "vds-radio-group",
          value: n.selectedValue,
          children: n.map(({ label: c, value: h, select: p }) => /* @__PURE__ */ s(
            f.Radio,
            {
              className: "vds-radio",
              value: h,
              onSelect: () => {
                var x;
                t(c), p(), (x = o.current) == null || x.close();
              },
              children: [
                /* @__PURE__ */ e(V, { className: "vds-icon" }),
                /* @__PURE__ */ e("span", { className: "vds-radio-label", children: c })
              ]
            },
            h
          ))
        }
      )
    }
  );
  return /* @__PURE__ */ s(
    f.Root,
    {
      ref: o,
      className: "vds-menu",
      children: [
        /* @__PURE__ */ s(d.Root, { children: [
          /* @__PURE__ */ e(d.Trigger, { asChild: !0, children: /* @__PURE__ */ e(f.Button, { className: "vds-menu-button vds-button", children: i === "Off" ? /* @__PURE__ */ e(q, {}) : /* @__PURE__ */ e(_, {}) }) }),
          /* @__PURE__ */ s(d.Content, { className: "vds-tooltip-content", children: [
            "Captions (",
            i,
            ")"
          ] })
        ] }),
        r
      ]
    }
  );
}, Qt = ({ onClose: t }) => {
  const n = A();
  return /* @__PURE__ */ s(d.Root, { children: [
    /* @__PURE__ */ e(d.Trigger, { asChild: !0, children: /* @__PURE__ */ e(
      "button",
      {
        type: "button",
        className: "vds-button vds-button-close",
        "aria-label": "Close",
        onClick: () => {
          n.pause(), t();
        },
        children: /* @__PURE__ */ e(bt, { className: "vds-icon" })
      }
    ) }),
    /* @__PURE__ */ e(d.Content, { className: "vds-tooltip-content", children: "Close" })
  ] });
}, R = ({
  shareLink: t,
  onShare: n = () => {
  },
  onShareSuccess: i = () => {
  },
  tooltipPosition: l
}) => {
  const { isSmallLayout: o } = k(), r = B(null), [a, c] = I(!1), [h, p] = I(!1), x = () => {
    if (t) {
      if (h) {
        p(!1);
        return;
      }
      n(), qt({
        string: t,
        permittedCallback: () => {
          c(!0), i();
        },
        deniedCallback: () => {
          p(!0);
        }
      });
    }
  };
  return /* @__PURE__ */ s(C, { children: [
    /* @__PURE__ */ e(
      _t,
      {
        title: "Copy link",
        placement: l,
        shouldHighlightChildIcon: !1,
        children: /* @__PURE__ */ e(Lt, { sx: { "& button": { m: u.md, "& svg": { color: "white" } } }, children: /* @__PURE__ */ e(
          "button",
          {
            ref: r,
            type: "button",
            onClick: x,
            className: "vds-button",
            children: /* @__PURE__ */ e(
              N,
              {
                icon: zt,
                style: { width: o ? 20 : 28, height: o ? 20 : 28 }
              }
            )
          }
        ) })
      }
    ),
    /* @__PURE__ */ e(
      J,
      {
        anchorEl: r.current,
        open: a || h,
        placement: "left",
        transition: !0,
        disablePortal: !0,
        children: ({ TransitionProps: b }) => /* @__PURE__ */ e(
          z,
          {
            ...b,
            timeout: {
              enter: 1500,
              exit: 500
            },
            onTransitionEnd: () => {
              a && c(!1);
            },
            children: a || h ? /* @__PURE__ */ e(
              m,
              {
                sx: (g) => ({
                  py: u.xxs,
                  px: u.md,
                  mx: u.sm,
                  borderRadius: y.xxs,
                  background: g.palette.common.white,
                  color: g.palette.common.black,
                  border: "1px solid rgb(0 0 0 / 0.2)",
                  width: "max-content"
                }),
                children: /* @__PURE__ */ s(
                  S,
                  {
                    variant: "text",
                    size: "xs",
                    children: [
                      !!a && "Link copied to clipboard",
                      !!h && "Copy the link manually"
                    ]
                  }
                )
              }
            ) : /* @__PURE__ */ e(m, {})
          }
        )
      }
    ),
    /* @__PURE__ */ e(
      J,
      {
        anchorEl: r.current,
        open: h,
        placement: "bottom-end",
        transition: !0,
        disablePortal: !0,
        children: ({ TransitionProps: b }) => /* @__PURE__ */ e(
          z,
          {
            ...b,
            timeout: {
              enter: 1500,
              exit: 500
            },
            children: /* @__PURE__ */ e(
              m,
              {
                sx: {
                  "& input": {
                    width: "100%",
                    textAlign: "center",
                    background: "transparent",
                    border: "none",
                    wordBreak: "break-word",
                    fontWeight: 600,
                    fontSize: "16px",
                    cursor: "pointer",
                    color: "transparent",
                    textShadow: "0 0 0 #FFF",
                    "&:focus-visible": {
                      outline: "none"
                    }
                  },
                  "& [data-url-share-placeholder]": {
                    height: 0,
                    padding: 0,
                    margin: 0,
                    overflow: "hidden",
                    clip: "rect(0, 0, 0, 0)",
                    whiteSpace: "nowrap"
                  }
                },
                children: /* @__PURE__ */ s(m, { children: [
                  /* @__PURE__ */ e(
                    "input",
                    {
                      ref: (g) => {
                        g == null || g.focus(), g == null || g.select(), g == null || g.setSelectionRange(0, 99999);
                      },
                      defaultValue: t,
                      onClick: () => {
                        window.open(t, "_blank"), p(!1);
                      },
                      type: "text",
                      readOnly: !0,
                      onCopy: () => {
                        p(!1);
                      }
                    }
                  ),
                  /* @__PURE__ */ e(m, { "data-url-share-placeholder": !0, children: t })
                ] })
              }
            )
          }
        )
      }
    )
  ] });
}, Y = ({ direction: t, onChange: n = () => {
} }) => {
  const i = v("currentTime"), l = M("chapters"), o = j(l);
  if (!o.length)
    return null;
  const r = o.findIndex((x) => x.startTime <= i && x.endTime > i);
  let a = null, c;
  t === "prev" && r > 0 && (c = r - 1, a = o[c]), t === "next" && r < o.length - 1 && (c = r + 1, a = o[r + 1]);
  const h = a ? a.startTime - i : 0, p = Number.isNaN(Number(a == null ? void 0 : a.text)) ? a == null ? void 0 : a.text : `${a == null ? void 0 : a.text}/${o.length}`;
  return /* @__PURE__ */ s(d.Root, { children: [
    /* @__PURE__ */ e(d.Trigger, { asChild: !0, children: /* @__PURE__ */ e(
      ht,
      {
        className: "vds-button",
        seconds: h,
        disabled: !a,
        ...(a == null ? void 0 : a.text) && { "aria-label": `Jump to '${p}'` },
        onChange: () => {
          n(c, t);
        },
        "data-testid": t === "prev" ? "prev-chapter-button" : "next-chapter-button",
        children: t === "prev" ? /* @__PURE__ */ e(Ct, {}) : /* @__PURE__ */ e(Tt, {})
      }
    ) }),
    !!(a != null && a.text) && /* @__PURE__ */ e(d.Content, { className: "vds-tooltip-content", children: p })
  ] });
}, Zt = ({ isEnabled: t, onToggle: n }) => /* @__PURE__ */ s(d.Root, { children: [
  /* @__PURE__ */ e(d.Trigger, { asChild: !0, children: /* @__PURE__ */ e(
    "button",
    {
      type: "button",
      className: "vds-button",
      "aria-label": "Toggle theatre mode",
      onClick: n,
      children: /* @__PURE__ */ e(
        N,
        {
          icon: t ? Ft : Ot,
          className: "vds-icon",
          size: "lg",
          style: { height: "65%" }
        }
      )
    }
  ) }),
  /* @__PURE__ */ e(d.Content, { className: "vds-tooltip-content", children: /* @__PURE__ */ s("span", { children: [
    t ? "Exit" : "Enter",
    " Theatre mode"
  ] }) })
] }), Pt = ({ isMinimized: t, onToggle: n }) => /* @__PURE__ */ s(d.Root, { children: [
  /* @__PURE__ */ e(d.Trigger, { asChild: !0, children: /* @__PURE__ */ e(
    "button",
    {
      type: "button",
      className: "vds-button",
      "aria-label": "Toggle minimized mode",
      onClick: n,
      children: t ? /* @__PURE__ */ e(
        N,
        {
          icon: Gt,
          className: "vds-icon",
          transform: { rotate: 90 },
          style: { height: "50%" }
        }
      ) : /* @__PURE__ */ e(
        N,
        {
          icon: Dt,
          className: "vds-icon",
          rotate: 90,
          transform: { rotate: 90 },
          style: { height: "50%" }
        }
      )
    }
  ) }),
  /* @__PURE__ */ e(d.Content, { className: "vds-tooltip-content", children: t ? "Minimize" : "Expand" })
] }), O = ({ direction: t, isDisabled: n = !1 }) => {
  const { prevVideo: i, nextVideo: l } = E(), o = () => {
    n || (t === "prev" ? i() : l());
  };
  return /* @__PURE__ */ s(d.Root, { children: [
    /* @__PURE__ */ e(d.Trigger, { asChild: !0, children: /* @__PURE__ */ e(
      "button",
      {
        type: "button",
        className: "vds-button vds-play-button vds-button-playlist-nav",
        onClick: o,
        disabled: n,
        children: t === "prev" ? /* @__PURE__ */ e(
          N,
          {
            icon: At,
            size: "lg",
            className: "vds-icon",
            style: { height: "40%" }
          }
        ) : /* @__PURE__ */ e(
          N,
          {
            icon: Wt,
            size: "lg",
            className: "vds-icon",
            style: { height: "40%" }
          }
        )
      }
    ) }),
    /* @__PURE__ */ e(d.Content, { className: "vds-tooltip-content", children: t === "prev" ? "Prev Video" : "Next Video" })
  ] });
}, te = ({ slot: t = null }) => {
  const n = v("paused"), i = v("ended"), l = v("started");
  return !n || !l || i ? null : /* @__PURE__ */ e(z, { in: !0, children: /* @__PURE__ */ e(
    m,
    {
      sx: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 10
      },
      children: t
    }
  ) });
}, ee = ({ src: t }) => /* @__PURE__ */ e(m, { sx: { width: "auto", height: 80, borderRadius: y.sm, overflow: "hidden" }, children: /* @__PURE__ */ e(
  "img",
  {
    src: t,
    alt: "brand logo",
    style: { objectFit: "cover", width: "100%", height: "100%" }
  }
) }), ne = ({ onWatermarkClick: t = () => {
} }) => v("paused") ? /* @__PURE__ */ e(
  m,
  {
    className: "watermark",
    sx: {
      position: "absolute",
      right: 0,
      left: 0,
      display: "flex",
      justifyContent: "center"
    },
    children: /* @__PURE__ */ s(
      m,
      {
        sx: (i) => ({
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: u.xs,
          cursor: "pointer",
          backgroundColor: $(i.palette.common.black, 0.3),
          px: u.sm,
          py: u.xxs,
          borderRadius: y.xl
        }),
        onClick: t,
        children: [
          /* @__PURE__ */ e(
            m,
            {
              sx: {
                fontSize: "9px"
              },
              children: "POWERED BY"
            }
          ),
          " ",
          /* @__PURE__ */ e(
            rt,
            {
              type: "full",
              variant: "light",
              width: 45,
              height: 14
            }
          )
        ]
      }
    )
  }
) : null, oe = () => {
  const t = v("started"), n = v("title"), i = M("chapters"), l = et();
  return i && (t || !n) ? /* @__PURE__ */ e(
    nt,
    {
      className: "vds-video-title",
      title: l
    }
  ) : /* @__PURE__ */ e(
    ot,
    {
      className: "vds-video-title",
      title: n
    }
  );
}, ie = () => {
  const t = v("title");
  return /* @__PURE__ */ e(
    ot,
    {
      title: t,
      className: "vds-video-title"
    }
  );
}, se = () => {
  const t = v("started"), n = v("title"), i = M("chapters"), l = et();
  return i && (t || !n) ? /* @__PURE__ */ e(
    nt,
    {
      className: "vds-video-title",
      title: l
    }
  ) : null;
}, le = ({ type: t = "videoOnly" }) => t === "videoOnly" ? /* @__PURE__ */ e(ie, {}) : t === "chapterOnly" ? /* @__PURE__ */ e(se, {}) : /* @__PURE__ */ e(oe, {}), W = ({
  placement: t = "bottom",
  type: n = "videoOnly",
  hasWatermark: i = !1,
  shareLink: l = "",
  disableOpenLink: o = !1
}) => {
  const { isSmallLayout: r } = k(), a = !o && !!l, c = a ? "pointer" : "default";
  return /* @__PURE__ */ s(
    m,
    {
      sx: {
        display: "flex",
        alignItems: "center",
        width: "100%",
        overflow: "hidden",
        ...!!i && t === "top" && {
          mt: u.sm,
          ml: u.sm
        },
        ...t === "bottom" && !r && {
          "& .vds-video-title:before": {
            content: '"•"',
            display: "inline-block",
            mr: u.sm
          }
        }
      },
      children: [
        !!i && t === "top" && !!l && /* @__PURE__ */ e(
          m,
          {
            onClick: () => {
              a && window.open(l, "_blank");
            },
            sx: { cursor: c },
            children: /* @__PURE__ */ e(
              rt,
              {
                type: "singleLetter",
                variant: "brand",
                width: r ? 30 : 40,
                height: r ? 30 : 40
              }
            )
          }
        ),
        /* @__PURE__ */ e(
          m,
          {
            sx: {
              flexGrow: 1,
              px: u.md,
              maxWidth: "90%",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              color: "rgba(255 255 255 / 0.64)",
              ...t === "top" && {
                fontSize: r ? "14px" : "18px",
                fontWeight: "bold"
              },
              lineHeight: r ? "16px" : "20px"
            },
            children: /* @__PURE__ */ e(le, { type: n })
          }
        )
      ]
    }
  );
}, K = ({
  translations: t = [],
  activeTranslation: n = void 0,
  onChange: i = () => {
  }
}) => {
  const l = B(null);
  if (!t.length || !n)
    return null;
  const o = /* @__PURE__ */ e(
    f.Content,
    {
      className: "vds-menu-items",
      placement: "top end",
      children: /* @__PURE__ */ e(
        f.RadioGroup,
        {
          className: "vds-radio-group",
          value: n.langCode,
          children: t.map(({ langCode: r, langName: a }) => /* @__PURE__ */ s(
            f.Radio,
            {
              className: "vds-radio",
              value: r,
              onSelect: () => {
                var c;
                i(r), (c = l.current) == null || c.close();
              },
              children: [
                /* @__PURE__ */ e(V, { className: "vds-icon" }),
                /* @__PURE__ */ e("span", { className: "vds-radio-label", children: a })
              ]
            },
            r
          ))
        }
      )
    }
  );
  return /* @__PURE__ */ s(
    f.Root,
    {
      ref: l,
      className: "vds-menu",
      children: [
        /* @__PURE__ */ s(d.Root, { children: [
          /* @__PURE__ */ e(d.Trigger, { asChild: !0, children: /* @__PURE__ */ e(f.Button, { className: "vds-menu-button vds-button", children: /* @__PURE__ */ e(Nt, { size: 32 }) }) }),
          /* @__PURE__ */ s(d.Content, { className: "vds-tooltip-content", children: [
            "Language: ",
            n.langName
          ] })
        ] }),
        o
      ]
    }
  );
}, Q = () => {
  const t = pt(), n = t.selectedValue === "1" ? "Normal" : `${t.selectedValue}x`, i = B(null);
  if (!v("canSetPlaybackRate"))
    return null;
  const o = /* @__PURE__ */ e(
    f.Content,
    {
      className: "vds-menu-items",
      placement: "top end",
      children: /* @__PURE__ */ e(
        f.RadioGroup,
        {
          className: "vds-radio-group",
          value: t.selectedValue,
          children: t.map(({ label: r, value: a, select: c }) => /* @__PURE__ */ s(
            f.Radio,
            {
              className: "vds-radio",
              value: a,
              onSelect: () => {
                var h;
                c(), (h = i.current) == null || h.close();
              },
              children: [
                /* @__PURE__ */ e(V, { className: "vds-icon" }),
                /* @__PURE__ */ e("span", { className: "vds-radio-label", children: r })
              ]
            },
            a
          ))
        }
      )
    }
  );
  return /* @__PURE__ */ s(
    f.Root,
    {
      ref: i,
      className: "vds-menu",
      children: [
        /* @__PURE__ */ s(d.Root, { children: [
          /* @__PURE__ */ e(d.Trigger, { asChild: !0, children: /* @__PURE__ */ e(f.Button, { className: "vds-menu-button vds-button", children: /* @__PURE__ */ e(St, {}) }) }),
          /* @__PURE__ */ s(d.Content, { className: "vds-tooltip-content", children: [
            "Speed (",
            n,
            ")"
          ] })
        ] }),
        o
      ]
    }
  );
}, F = ({ isInCenter: t = !1 }) => {
  const n = v("paused"), i = v("ended");
  return i && t ? null : /* @__PURE__ */ s(d.Root, { children: [
    /* @__PURE__ */ e(d.Trigger, { asChild: !0, children: /* @__PURE__ */ e(it, { className: `vds-button ${t ? "vds-play-button-center vds-play-button" : ""} `, children: i ? /* @__PURE__ */ e(lt, { className: "vds-icon" }) : n ? /* @__PURE__ */ e(yt, { className: "vds-icon" }) : /* @__PURE__ */ e(It, { className: "vds-icon" }) }) }),
    /* @__PURE__ */ e(d.Content, { className: "vds-tooltip-content", children: i ? "Replay" : n ? "Play" : "Pause" })
  ] });
}, Z = () => {
  const t = v("pictureInPicture"), n = async () => {
    try {
      await document.exitPictureInPicture();
    } catch {
    }
  };
  return D(() => (window.addEventListener("unhandledrejection", (i) => {
    var l, o;
    (o = (l = i.reason) == null ? void 0 : l.message) != null && o.includes("Cannot read properties of null (reading 'pictureInPicture')") && i.preventDefault();
  }), () => {
    n();
  }), []), /* @__PURE__ */ s(d.Root, { children: [
    /* @__PURE__ */ e(d.Trigger, { asChild: !0, children: /* @__PURE__ */ e(ft, { className: "vds-pip-button vds-button", children: t ? /* @__PURE__ */ e(wt, { className: "vds-icon" }) : /* @__PURE__ */ e(kt, { className: "vds-icon" }) }) }),
    /* @__PURE__ */ e(d.Content, { className: "vds-tooltip-content", children: t ? "Exit PiP" : "Enter PiP" })
  ] });
}, re = (t) => {
  const [n, i] = I(!1);
  return D(() => {
    if (!t)
      return;
    const l = () => {
      i(!0);
    }, o = () => {
      i(!1);
    };
    return t.addEventListener("mouseenter", l), t.addEventListener("mouseleave", o), () => {
      t.removeEventListener("mouseenter", l), t.removeEventListener("mouseleave", o);
    };
  }, [t]), n;
}, ae = (t) => {
  const [n, i] = I(!1);
  return D(() => {
    if (!t)
      return;
    const l = () => {
      i(!0);
    }, o = () => {
      i(!1);
    };
    return t.addEventListener("focusin", l), t.addEventListener("focusout", o), () => {
      t.removeEventListener("focusin", l), t.removeEventListener("focusout", o);
    };
  }, [t]), n;
}, ce = (t) => {
  const n = re(t), i = ae(t), l = B(!1);
  return l.current && !n ? !1 : (l.current = n, n || i);
}, de = () => {
  const t = v("volume"), n = v("muted"), [i, l] = I(null), o = ce(i);
  return /* @__PURE__ */ s(
    "div",
    {
      ref: l,
      className: "vds-volume-custom",
      "data-active": o ? "" : null,
      children: [
        /* @__PURE__ */ s(d.Root, { children: [
          /* @__PURE__ */ e(d.Trigger, { asChild: !0, children: /* @__PURE__ */ e(vt, { className: "vds-button", children: n || t === 0 ? /* @__PURE__ */ e(Bt, {}) : t < 0.5 ? /* @__PURE__ */ e(Rt, {}) : /* @__PURE__ */ e(Mt, {}) }) }),
          /* @__PURE__ */ e(d.Content, { className: "vds-tooltip-content", children: n ? "Unmute" : "Mute" })
        ] }),
        /* @__PURE__ */ e("div", { className: "vds-volume-popup-custom", children: /* @__PURE__ */ s(
          w.Root,
          {
            orientation: "horizontal",
            className: "vds-volume-slider-custom vds-slider",
            children: [
              /* @__PURE__ */ e(w.Track, { className: "vds-slider-track", children: /* @__PURE__ */ e(w.TrackFill, { className: "vds-slider-track-fill vds-slider-track" }) }),
              /* @__PURE__ */ e(w.Thumb, { className: "vds-slider-thumb" }),
              /* @__PURE__ */ e(
                w.Preview,
                {
                  className: "vds-slider-preview",
                  noClamp: !0,
                  children: /* @__PURE__ */ e(w.Value, { className: "vds-slider-value" })
                }
              )
            ]
          }
        ) })
      ]
    }
  );
}, ue = () => {
  const { thumbnails: t } = k();
  return /* @__PURE__ */ s(T.Root, { className: "vds-time-slider vds-slider", children: [
    /* @__PURE__ */ e(T.Chapters, { className: "vds-slider-chapters", children: (n, i) => n.map((l) => {
      var r;
      const o = Number((r = n[n.length - 1]) == null ? void 0 : r.endTime);
      return /* @__PURE__ */ s(
        m,
        {
          ref: i,
          className: "vds-slider-chapter",
          sx: {
            minWidth: `calc(${((l.endTime - l.startTime) / o * 100).toFixed(2)}% - 2px) !important`,
            maxWidth: `calc(${((l.endTime - l.startTime) / o * 100).toFixed(2)}% - 2px) !important`
          },
          children: [
            /* @__PURE__ */ e(T.Track, { className: "vds-slider-track" }),
            /* @__PURE__ */ e(T.TrackFill, { className: "vds-slider-track-fill vds-slider-track" }),
            /* @__PURE__ */ e(T.Progress, { className: "vds-slider-progress vds-slider-track" })
          ]
        },
        l.startTime
      );
    }) }),
    /* @__PURE__ */ s(T.Preview, { className: "vds-slider-preview", children: [
      !!t && /* @__PURE__ */ e(
        T.Thumbnail.Root,
        {
          src: t,
          className: "vds-slider-thumbnail vds-thumbnail",
          children: /* @__PURE__ */ e(T.Thumbnail.Img, {})
        }
      ),
      /* @__PURE__ */ e(T.ChapterTitle, { className: "vds-slider-chapter-title" }),
      /* @__PURE__ */ e(T.Value, { className: "vds-slider-value" })
    ] }),
    /* @__PURE__ */ e(T.Thumb, { className: "vds-slider-thumb" })
  ] });
}, P = () => {
  const { isAutoplayOn: t, toggleAutoplay: n } = E();
  return /* @__PURE__ */ s(d.Root, { children: [
    /* @__PURE__ */ e(d.Trigger, { asChild: !0, children: /* @__PURE__ */ e(
      "button",
      {
        type: "button",
        className: "vds-button",
        "aria-label": "Toggle playlist autoplay",
        onClick: n,
        children: /* @__PURE__ */ e(
          N,
          {
            icon: t ? jt : Vt,
            size: "lg",
            className: "vds-icon",
            style: { height: "55%" }
          }
        )
      }
    ) }),
    /* @__PURE__ */ s(d.Content, { className: "vds-tooltip-content", children: [
      "Playlist autoplay (",
      t ? "on" : "off",
      ")"
    ] })
  ] });
}, me = (t) => {
  const n = new Date(Number(t) * 1e3);
  return new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric"
  }).format(n);
}, tt = () => {
  const { isSmallLayout: t } = k(), n = B(null), { playlist: i, videoIndex: l, goToVideo: o } = E();
  if (!(i != null && i.length))
    return null;
  const r = /* @__PURE__ */ e(
    f.Content,
    {
      className: "vds-menu-items",
      placement: t ? null : "top end",
      children: /* @__PURE__ */ e(
        f.RadioGroup,
        {
          className: "vds-chapters-radio-group vds-radio-group",
          value: String(l),
          children: i.map(({ poster: a, title: c, author: h, createdAt: p, viewsAmount: x }, b) => /* @__PURE__ */ e(
            f.Radio,
            {
              className: "vds-chapter-radio vds-radio",
              value: String(b),
              onSelect: () => {
                var g;
                o(b), (g = n.current) == null || g.close();
              },
              children: /* @__PURE__ */ s(
                m,
                {
                  sx: {
                    display: "flex",
                    alignItems: "center",
                    gap: u.lg,
                    width: "100%"
                  },
                  children: [
                    !!a && /* @__PURE__ */ e(
                      m,
                      {
                        sx: {
                          width: t ? 70 : 120
                        },
                        children: /* @__PURE__ */ e(
                          "img",
                          {
                            src: a,
                            alt: "poster",
                            style: { width: "100%", height: "100%", objectFit: "cover" }
                          }
                        )
                      }
                    ),
                    /* @__PURE__ */ s(
                      m,
                      {
                        sx: {
                          display: "flex",
                          flexDirection: "column",
                          width: "100%",
                          maxWidth: `calc(100% - ${t ? 70 : 120}px)`
                        },
                        children: [
                          /* @__PURE__ */ e(
                            m,
                            {
                              sx: {
                                "& .MuiTypography-root": {
                                  width: "100%",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap"
                                }
                              },
                              children: /* @__PURE__ */ e(S, { variant: "text", children: c })
                            }
                          ),
                          !!h && /* @__PURE__ */ e(
                            S,
                            {
                              variant: "text",
                              size: "sm",
                              children: h
                            }
                          ),
                          /* @__PURE__ */ s(m, { sx: { display: "flex", alignItems: "center", justifyContent: "space-between" }, children: [
                            !!p && /* @__PURE__ */ e(
                              S,
                              {
                                variant: "text",
                                size: "sm",
                                children: me(p)
                              }
                            ),
                            !!x && /* @__PURE__ */ s(m, { sx: { display: "flex", alignItems: "center", gap: u.xs }, children: [
                              /* @__PURE__ */ e(N, { icon: $t }),
                              /* @__PURE__ */ e(
                                S,
                                {
                                  variant: "text",
                                  size: "sm",
                                  children: x
                                }
                              )
                            ] })
                          ] })
                        ]
                      }
                    )
                  ]
                }
              )
            },
            b
          ))
        }
      )
    }
  );
  return /* @__PURE__ */ s(
    f.Root,
    {
      ref: n,
      className: "vds-menu vds-menu--playlist",
      children: [
        /* @__PURE__ */ s(d.Root, { children: [
          /* @__PURE__ */ e(d.Trigger, { asChild: !0, children: /* @__PURE__ */ e(f.Button, { className: "vds-menu-button vds-button", children: /* @__PURE__ */ e(Et, {}) }) }),
          /* @__PURE__ */ e(d.Content, { className: "vds-tooltip-content", children: "Playlist" })
        ] }),
        t ? /* @__PURE__ */ e(
          f.Portal,
          {
            className: "vds-video-layout light vds-menu-portal--playlist",
            disabled: "fullscreen",
            children: r
          }
        ) : r
      ]
    }
  );
}, he = {
  settingsMenu: null,
  chaptersMenu: null,
  liveButton: null,
  downloadButton: null,
  airPlayButton: null,
  googleCastButton: null,
  timeDivider: null,
  currentTime: null,
  volumeSlider: null,
  timeSlider: null,
  startDuration: null,
  endTime: null,
  muteButton: null,
  playButton: null,
  captionButton: null,
  captions: null,
  fullscreenButton: null,
  afterFullscreenButton: null,
  centerControlsGroupStart: null,
  centerControlsGroupEnd: null,
  smallLayout: {
    topControlsGroupStart: null,
    beforeFullscreenButton: null,
    beforeCaptionButton: null,
    chapterTitle: null,
    pipButton: null,
    centerControlsGroupCenter: /* @__PURE__ */ e(F, { isInCenter: !0 })
  },
  largeLayout: {
    topControlsGroupStart: null,
    beforeFullscreenButton: null,
    beforeCaptionButton: null,
    chapterTitle: null,
    pipButton: null,
    centerControlsGroupCenter: /* @__PURE__ */ e(F, { isInCenter: !0 })
  }
}, pe = () => v("ended") ? /* @__PURE__ */ s(d.Root, { children: [
  /* @__PURE__ */ e(d.Trigger, { asChild: !0, children: /* @__PURE__ */ e(it, { className: "vds-button", children: /* @__PURE__ */ e(lt, {}) }) }),
  /* @__PURE__ */ e(d.Content, { className: "vds-tooltip-content", children: "Replay" })
] }) : null, fe = ({ playerProps: t, shareLink: n = "" }) => {
  const i = v("ended"), { isPlaylist: l } = E();
  return i ? /* @__PURE__ */ e(z, { in: !0, children: /* @__PURE__ */ e(
    m,
    {
      sx: (o) => ({
        position: "absolute",
        inset: 0,
        zIndex: 11,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: $(o.palette.common.black, 0.5),
        backdropFilter: "blur(4px)"
      }),
      children: /* @__PURE__ */ s(
        m,
        {
          sx: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%"
          },
          children: [
            !!(l || t.hasPlaylistControlsOnly) && /* @__PURE__ */ s(C, { children: [
              /* @__PURE__ */ e("div", { className: "vds-controls-spacer" }),
              /* @__PURE__ */ e(
                O,
                {
                  direction: "prev",
                  isDisabled: t.isPlaylistNavDisabled
                }
              ),
              /* @__PURE__ */ e("div", { className: "vds-controls-spacer" })
            ] }),
            /* @__PURE__ */ s(
              m,
              {
                sx: {
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: u["4xl"]
                },
                children: [
                  !!t.hasBranding && !!t.brandLogoSrc && /* @__PURE__ */ e(ee, { src: t.brandLogoSrc }),
                  /* @__PURE__ */ s(m, { sx: { display: "flex", alignItems: "center" }, children: [
                    /* @__PURE__ */ e(pe, {}),
                    !!t.hasShareButton && !!n && /* @__PURE__ */ e(
                      R,
                      {
                        shareLink: n,
                        onShare: t.onShare,
                        onShareSuccess: t.onShareSuccess,
                        tooltipPosition: "bottom"
                      }
                    )
                  ] })
                ]
              }
            ),
            !!(l || t.hasPlaylistControlsOnly) && /* @__PURE__ */ s(C, { children: [
              /* @__PURE__ */ e("div", { className: "vds-controls-spacer" }),
              /* @__PURE__ */ e(
                O,
                {
                  direction: "next",
                  isDisabled: t.isPlaylistNavDisabled
                }
              ),
              /* @__PURE__ */ e("div", { className: "vds-controls-spacer" })
            ] }),
            t.endScreenSlot
          ]
        }
      )
    }
  ) }) : null;
}, Kn = ({
  playerProps: t,
  translations: n = [],
  thumbnails: i = [],
  ctas: l = [],
  shareLink: o = ""
}) => {
  const { isPlaylist: r } = E(), a = v("started"), c = !!t.hasCloseButton && typeof t.onClose == "function", h = !!t.hasOnlyPlayButtonInitially && !a, p = st(() => h ? he : {
    timeSlider: /* @__PURE__ */ e(ue, {}),
    ...t.hasTimeIndication === !1 && {
      currentTime: null,
      timeDivider: null,
      endTime: null,
      startDuration: null
    },
    ...t.hasCaptions ? {
      captionButton: /* @__PURE__ */ e(X, { onChange: t.onCaptionsChange })
    } : {
      captions: null,
      captionButton: null
    },
    ...!t.hasFullscreenMode && {
      fullscreenButton: null
    },
    afterFullscreenButton: /* @__PURE__ */ s(C, { children: [
      !!t.hasTheatreMode && typeof t.isTheatreModeEnabled < "u" && typeof t.onTheatreModeToggle == "function" && /* @__PURE__ */ e(
        Zt,
        {
          isEnabled: t.isTheatreModeEnabled,
          onToggle: t.onTheatreModeToggle
        }
      ),
      !!t.hasMinimizedMode && typeof t.isMinimizedModeEnabled < "u" && typeof t.onMinimizedModeToggle == "function" && /* @__PURE__ */ e(
        Pt,
        {
          isMinimized: t.isMinimizedModeEnabled,
          onToggle: t.onMinimizedModeToggle
        }
      )
    ] }),
    ...(r || t.hasPlaylistControlsOnly) && {
      centerControlsGroupStart: /* @__PURE__ */ s(C, { children: [
        /* @__PURE__ */ e("div", { className: "vds-controls-spacer" }),
        /* @__PURE__ */ e(
          O,
          {
            direction: "prev",
            isDisabled: t.isPlaylistNavDisabled
          }
        ),
        /* @__PURE__ */ e("div", { className: "vds-controls-spacer" })
      ] }),
      centerControlsGroupEnd: /* @__PURE__ */ s(C, { children: [
        /* @__PURE__ */ e("div", { className: "vds-controls-spacer" }),
        /* @__PURE__ */ e(
          O,
          {
            direction: "next",
            isDisabled: t.isPlaylistNavDisabled
          }
        ),
        /* @__PURE__ */ e("div", { className: "vds-controls-spacer" })
      ] })
    },
    smallLayout: {
      ...t.hasTimeIndication === !1 && {
        currentTime: null,
        timeDivider: null,
        endTime: null
      },
      startDuration: null,
      chapterTitle: null,
      muteButton: null,
      volumeSlider: null,
      captionButton: null,
      topControlsGroupStart: /* @__PURE__ */ s(C, { children: [
        !!t.hasShareButton && !!o && t.shareButtonPosition === "left" && /* @__PURE__ */ e(
          R,
          {
            shareLink: o,
            onShare: t.onShare,
            onShareSuccess: t.onShareSuccess,
            tooltipPosition: "bottom-start"
          }
        ),
        !!t.hasTopTitle && /* @__PURE__ */ e(
          W,
          {
            placement: "top",
            type: t.topTitleType,
            hasWatermark: t.hasWatermark,
            shareLink: o,
            disableOpenLink: !t.hasShareButton
          }
        )
      ] }),
      beforeFullscreenButton: /* @__PURE__ */ s(C, { children: [
        !!t.hasTranslations && /* @__PURE__ */ e(
          K,
          {
            onChange: t.onTranslationChange,
            translations: n,
            activeTranslation: t.activeTranslation
          }
        ),
        !!t.hasSpeedMenu && /* @__PURE__ */ e(Q, {}),
        !!t.hasCaptions && /* @__PURE__ */ e(X, { onChange: t.onCaptionsChange }),
        !!t.hasPIPMode && /* @__PURE__ */ e(Z, {})
      ] }),
      ...(r || t.hasPlaylistControlsOnly) && {
        afterChapterTitle: !!t.isPlaylistAutoplayBehaviorOn && !!t.hasPlaylistAutoplaySwitcher && /* @__PURE__ */ e(P, {})
      },
      topControlsGroupEnd: /* @__PURE__ */ s(C, { children: [
        !!t.hasShareButton && !!o && t.shareButtonPosition === "right" && /* @__PURE__ */ e(
          R,
          {
            shareLink: o,
            onShare: t.onShare,
            onShareSuccess: t.onShareSuccess,
            tooltipPosition: "bottom-end"
          }
        ),
        !!r && !!t.hasPlaylistMenu && /* @__PURE__ */ e(tt, {}),
        !!c && /* @__PURE__ */ e("div", { className: "space-for-close-btn" })
      ] }),
      beforeCurrentTime: /* @__PURE__ */ s(C, { children: [
        /* @__PURE__ */ e(F, {}),
        /* @__PURE__ */ e(de, {})
      ] })
    },
    largeLayout: {
      topControlsGroupStart: (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        /* @__PURE__ */ s(C, { children: [
          !!t.hasShareButton && !!o && t.shareButtonPosition === "left" && /* @__PURE__ */ e(
            R,
            {
              shareLink: o,
              onShare: t.onShare,
              onShareSuccess: t.onShareSuccess,
              tooltipPosition: "bottom-start"
            }
          ),
          !!t.hasTopTitle && /* @__PURE__ */ e(
            W,
            {
              placement: "top",
              type: t.topTitleType,
              hasWatermark: t.hasWatermark,
              shareLink: o,
              disableOpenLink: !t.hasShareButton
            }
          )
        ] })
      ),
      centerControlsGroupCenter: /* @__PURE__ */ e(F, { isInCenter: !0 }),
      chapterTitle: t.hasBottomTitle ? /* @__PURE__ */ e(
        W,
        {
          placement: "bottom",
          type: t.bottomTitleType
        }
      ) : (
        // keeps place at the controls bar when title is disabled
        /* @__PURE__ */ e(m, { flexGrow: 1 })
      ),
      pipButton: t.hasPIPMode ? /* @__PURE__ */ e(Z, {}) : null,
      ...t.hasChapterNav && {
        beforeMuteButton: /* @__PURE__ */ s(C, { children: [
          /* @__PURE__ */ e(
            Y,
            {
              direction: "prev",
              onChange: t.onChapterNav
            }
          ),
          /* @__PURE__ */ e(
            Y,
            {
              direction: "next",
              onChange: t.onChapterNav
            }
          )
        ] })
      },
      ...(!!t.hasSpeedMenu || !!t.hasTranslations) && {
        beforeCaptionButton: /* @__PURE__ */ s(C, { children: [
          !!t.hasTranslations && /* @__PURE__ */ e(
            K,
            {
              onChange: t.onTranslationChange,
              translations: n,
              activeTranslation: t.activeTranslation
            }
          ),
          !!t.hasSpeedMenu && /* @__PURE__ */ e(Q, {})
        ] })
      },
      topControlsGroupEnd: /* @__PURE__ */ s(C, { children: [
        !!t.hasShareButton && !!o && t.shareButtonPosition === "right" && /* @__PURE__ */ e(
          R,
          {
            shareLink: o,
            onShare: t.onShare,
            onShareSuccess: t.onShareSuccess,
            tooltipPosition: "bottom-end"
          }
        ),
        !!c && /* @__PURE__ */ e("div", { className: "space-for-close-btn" })
      ] }),
      afterChapterTitle: /* @__PURE__ */ s(C, { children: [
        !!(r || t.hasPlaylistControlsOnly) && !!t.isPlaylistAutoplayBehaviorOn && !!t.hasPlaylistAutoplaySwitcher && /* @__PURE__ */ e(P, {}),
        !!r && !!t.hasPlaylistMenu && /* @__PURE__ */ e(tt, {})
      ] })
    },
    // removed because of no use
    chaptersMenu: null,
    settingsMenu: null,
    liveButton: null,
    downloadButton: null,
    airPlayButton: null,
    googleCastButton: null
  }, [h, r, t, o, c, n]);
  return /* @__PURE__ */ s(
    gt,
    {
      icons: xt,
      thumbnails: i,
      colorScheme: "light",
      noGestures: !t.hasGestures,
      smallLayoutWhen: ({ width: x, height: b }) => x <= 650 || b < 380,
      slots: p,
      children: [
        !!t.hasCTAs && !!l.length && /* @__PURE__ */ e(
          Kt,
          {
            ctas: l,
            onCtaClick: t.onCtaClick
          }
        ),
        !!c && /* @__PURE__ */ e("div", { className: "vds-button-close-container", children: /* @__PURE__ */ e(Qt, { onClose: t.onClose }) }),
        !!t.hasWatermark && /* @__PURE__ */ e(ne, { onWatermarkClick: t.onWatermarkClick }),
        !!t.hasPauseScreen && /* @__PURE__ */ e(te, { slot: t.pauseScreenSlot }),
        !!t.hasEndScreen && /* @__PURE__ */ e(
          fe,
          {
            playerProps: t,
            shareLink: o
          }
        )
      ]
    }
  );
};
export {
  Kn as L
};
